<template>

  <loading-indicator v-if="loading" />

  <div v-else-if="profile_inaccessible_error" class="alert alert-danger mt-4">
    {{ profile_inaccessible_error }}
    <span>
      İsterseniz
    <router-link :to="{name : 'landing-screen'}">
      Buradan
    </router-link>
      Gezintinize Devam Edebilirsiniz
    </span>
  </div>

  <div class="row mt-4" v-else-if="profile">

    <div class="col-12 p-4 alert alert-warning" v-if="profile.on_vacation">
      Bu kullanıcı tatil modundadır.
    </div>

    <div class="col-md-3" v-if="profile.id !== api.user.id">





      <user-maxi-header :profile="profile" />




    </div>



    <div :class="[profile.id !== api.user.id ? 'col-md-9' : 'col-12']">





      <b-tabs class="zebramo-custom-tabs">
        <b-tab :title="`${productsCount} Ürün`" active>
          <product-list-view v-if="products"
                              :initial_data="products"
                              grid_classes="col-6 col-md-4 col-lg-4 col-xl-3">
          </product-list-view>
        </b-tab>

        <b-tab :title="`${soldProductsCount} Satılanlar`">
          <product-list-view v-if="sold_products"
                              :initial_data="sold_products"
                              grid_classes="col-6 col-md-4 col-lg-4 col-xl-3">
          </product-list-view>
        </b-tab>

        <b-tab :title="`${popularProductsCount} Popüler`">
          <product-list-view v-if="popular_products"
                              :show_social_info="false"
                              :initial_data="popular_products"
                              grid_classes="col-6 col-md-4 col-lg-4 col-xl-3">
          </product-list-view>
        </b-tab>

        <b-tab :title="`${followersCount} Takipçi`">
          <user-list-view v-if="followers"
                          :initial_data="followers"
                          grid_classes="col-6 col-md-4 col-lg-4 col-xl-3"
                          :show_follow_btn="true"
                          :pagination="true">
          </user-list-view>
        </b-tab>

        <b-tab :title="`${followingCount} Takip Ettikleri`">
          <user-list-view v-if="following"
                          :initial_data="following"
                          grid_classes="col-6 col-md-4 col-lg-4 col-xl-3"
                          :show_follow_btn="true"
                          :pagination="true">
          </user-list-view>
        </b-tab>
      </b-tabs>





    </div>
  </div>
</template>

<script>
import UserListView from '../../listviews/UserListView'
import RatingStars from '../../misc/RatingStars'
import UserMaxiHeader from '../../misc/UserMaxiHeader'

export default {
  name: 'profile-home',
  props: ['id'],
  components: {
    UserListView,
    UserMaxiHeader,
    RatingStars,
  },
  data() {

    return {
      profile_id: null,
      loading: true,
      profile_inaccessible_error: '',
      profile: null,
      products: null,
      sold_products: null,
      popular_products: null,
      followers: null,
      following: null,
      productsCount: 0,
      soldProductsCount: 0,
      popularProductsCount: 0,
      followersCount: 0,
      followingCount: 0
    }
  },
  computed: {
    is_this_me() {

      return this.id === this.api.user.id;
    }
    // titles() {
    //   return {
    //     products: this.products ? `${this.products.items.length} Ürün` : 'Ürün',
    //     sold_products: this.sold_products ? `${this.sold_products.items.length} Satılanlar` : 'Satılanlar',
    //     popular_products: this.popular_products ? `${this.popular_products.length} Popüler` : 'Popüler',
    //     followers: this.followers ? `${this.followers.items.length} Takipçi` : 'Takipçi',
    //     following: this.following ? `${this.following.items.length} Takip Ettikleri` : 'Takip Ettikleri',
    //   }
    // }
  },
  watch: {
    '$route': 'fetch_data'
  },
  created() {

    this.fetch_data()
  },
  methods: {
    fetch_data() {

      this.profile_id = this.id;
      if (!this.profile_id && this.api.user.id){
        this.profile_id = this.api.user.id; // if this is the logged user's own profile.
      }
      //
      // handle the old links from https://old.zebramo.com
      // google indexed them like this, so we're stuck with them.
      //
      if (this.profile_id.toString().length < 7) {
        this.profile_id = this.api.utils.int_from_base32(this.profile_id)
      }

      // force reload whole page.
      this.profile = null
      this.products = null
      this.sold_products = null
      this.popular_products = null
      this.followers = null
      this.following = null

      //
      // fetch profile
      //
      this.loading = true
      if(this.id === this.api.user.id){
        this.api.ops.GET.users_me({
          ignore_errors: true
        }).then(data => {
          this.api.patcher.patch_users_images({ items: [data.user] })
          this.profile = data.user;
          this.fetch_user_details()
          this.loading = false
        }).catch(reason => {
          this.loading = false;

          //
          // handle 404
          //
          if(reason.status === 404)
            this.profile_inaccessible_error = `Böyle bir kullanıcı bulunamadı.`
        })
      }else{
        this.api.ops.GET.users_(this.profile_id, {
          ignore_errors: true
        }).then((data) => {
          this.api.patcher.patch_users_images({ items: [data.user] })
          this.profile = data.user;

          this.fetch_user_details()

          this.loading = false
        }).catch(reason => {
          this.loading = false;

          //
          // handle 404
          //
          if(reason.status === 404)
            this.profile_inaccessible_error = `Böyle bir kullanıcı bulunamadı.`
        })
      }
    },
    fetch_user_details() {

      //
      // fetch products
      //
      let order_by = 'created';
      if(this.profile_id === this.api.user.id){
        this.api.ops.GET.users_products_all({
          status: 'listed',
          order_by
        }).then((data) => {
          this.api.patcher.patch_products(data.products);
          this.products = data.products;
          this.productsCount = data.products.total
        });

        //
        // some of the tabs are for authenticated users.
        //
        this.api.ops.GET.users_products_all({
          status: 'sold'
        }).then((data) => {
          this.api.patcher.patch_products(data.products);
          this.sold_products = data.products;
          this.soldProductsCount = data.products.total
        });

        this.api.ops.GET.users__popular_products(this.profile_id).then((data) => {
          //
          //
          // bu API muhtemelen sonradan eklenmis. normalde gelen product objelerine
          // benzemiyor; o yuzden gelen datayi burada patchleyecegiz...
          // -- @utku.
          //
          this.api.patcher.patch_products(data.products);
          this.popular_products = data.products; // @fkoksal api inconsistency (niye "products" degil?).
          this.popularProductsCount = data.products.total
        });

        this.api.ops.GET.users__followers(this.profile_id).then((data) => {
          this.api.patcher.patch_users_images(data.users)
          this.followers = data.users;
          this.followersCount = data.users.total
        });

        this.api.ops.GET.users__following(this.profile_id).then((data) => {
          this.api.patcher.patch_users_images(data.users)
          this.following = data.users;
          this.followingCount = data.users.total
        });
      }
      else{
        this.api.ops.GET.users__products(this.profile_id, {
          status: 'listed',
          order_by
        }).then((data) => {
          this.api.patcher.patch_products(data.products);
          this.products = data.products;
          this.productsCount = data.products.total
        });

        //
        // some of the tabs are for authenticated users.
        //
          this.api.ops.GET.users__products(this.profile_id, {
            status: 'sold'
          }).then((data) => {
            this.api.patcher.patch_products(data.products);
            this.sold_products = data.products;
            this.soldProductsCount = data.products.total
          });

          this.api.ops.GET.users__popular_products(this.profile_id).then((data) => {
            //
            //
            // bu API muhtemelen sonradan eklenmis. normalde gelen product objelerine
            // benzemiyor; o yuzden gelen datayi burada patchleyecegiz...
            // -- @utku.
            //
            this.api.patcher.patch_products(data.products);
            this.popular_products = data.products; // @fkoksal api inconsistency (niye "products" degil?).
            this.popularProductsCount = data.products.total
          });

          this.api.ops.GET.users__followers(this.profile_id).then((data) => {
            this.api.patcher.patch_users_images(data.users)
            this.followers = data.users;
            this.followersCount = data.users.total
          });

          this.api.ops.GET.users__following(this.profile_id).then((data) => {
            this.api.patcher.patch_users_images(data.users)
            this.following = data.users;
            this.followingCount = data.users.total
          });
      }
    },
    changeCount (type, data) {
      this[type] = data
    }
  }
}
</script>

<style scoped lang="scss">


</style>



// WEBPACK FOOTER //
// src/components/screens/profile/ProfileHome.vue